<template>
    <Mz-Dialog class="dialog" :title="title" width="2937px" :visible.sync="visible" @handleClose="handleClose">
        <div slot="content" class="main" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)">
            <p class="tip">GDT 价格指数通过使用在一次交易活动中由所有销售商在所有合同期内实现的全部产品总销量计算得出。</p>
            <div class="chart" id="chart"></div>
            <div class="chart2" id="chart2"></div>
            <p class="tip2">* 数据来源于 GDT</p>
        </div>
    </Mz-Dialog>
</template>

<script>
import echarts from 'echarts'
    export default {
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            data: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                loading: false
            }
        },
        created() {
        },
        mounted() {
            this.$nextTick(() => {
                this.echarts()
                this.echarts2()
            })
        },
        methods: {
            echarts(){
                var chart = echarts.init(document.getElementById('chart'));
                let dataX = this.data.map(it => {
                    return it.time
                })
                let dataY = this.data.map(it => {
                    return it.value
                })
                // 清空图表
                chart.clear();
                chart.setOption({
                    // 设置绘图区域的边距
                    grid: {
                        left: 0,   // 左侧距离
                        right: 60,  // 右侧距离
                        top: 84,   // 可选：顶部距离
                        bottom: 0, // 可选：底部距离
                        containLabel: true // 确保标签不被裁剪
                    },
                    tooltip: {
                        trigger: 'axis',
                        textStyle: {
                            color: '#fff',
                            fontSize: 36, 
                        },
                    },
                    xAxis: {
                        type: 'category',
                        data: dataX,
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#2A54A2', // 设置 x 轴线的颜色
                                width: 3
                            }
                        },
                        boundaryGap: false, // 去掉左右两边的空白
                        axisLabel: {
                            color: '#fff', // 文字颜色
                            fontSize: 28,   // 字体大小
                            margin: 24,
                            rotate: 45
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#2A54A2', // 设置 x 轴线的颜色
                                width: 3
                            }
                        },
                        splitLine: { 
                            lineStyle: {
                                color: '#2A54A2', // 设置 x 轴线的颜色
                                width: 3,
                                type: 'dashed',
                            }
                        },
                        axisTick: { show: false },
                        axisLabel: {
                            color: '#fff', // 文字颜色
                            fontSize: 30,   // 字体大小
                            margin: 45
                        },
                    },
                    series: [{
                        data: dataY,
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 24,
                        showSymbol: true,
                        itemStyle: {
                            color: '#061938',
                            borderColor: '#0CFBFF',
                            borderWidth: 3, 
                            borderType: 'solid'
                        },
                        lineStyle: {
                            color: '#0CFBFF', 
                            width: 3,
                            type: 'solid'
                        },
                    }]
                })
            },
            echarts2(){
                var chart = echarts.init(document.getElementById('chart2'));
                let dataX = this.data.map(it => {
                    return it.time
                })
                let dataY = this.data.map(it => {
                    return it.value
                })
                // 清空图表
                chart.clear();
                chart.setOption({
                    // 设置绘图区域的边距
                    grid: {
                        left: 0,   // 左侧距离
                        right: 0,  // 右侧距离
                        top: 0,   // 可选：顶部距离
                        bottom: 0, // 可选：底部距离
                        containLabel: true, // 确保标签不被裁剪
                        color: '#0E254A'
                    },
                    xAxis: {
                        type: 'category',
                        data: dataX,
                        axisTick: {show: false},
                        axisLine: {show: false},
                        boundaryGap: false, // 去掉左右两边的空白
                        axisLabel: {show: false}
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {show: false},
                        splitLine: { show: false },
                        axisTick: { show: false },
                        axisLabel: {show: false},
                    },
                    series: [{
                        data: dataY,
                        type: 'line',
                        showSymbol: false,
                        areaStyle: {
                            color: '#013C5C'
                        },
                        lineStyle: {
                            color: '#0CFBFF',
                            width: 3
                        }
                    }]
                })
            },
            handleClose(){
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style lang="less" scoped>
@import '@/styles/common';
.chart{
    width: 100%;
    height: 627px;
}
.chart2{
    width: calc(100% - 187px);
    height: 237px;
    margin: 54px 60px 55px 127px;
    background: #0E254A;
    padding-top: 60px;
}
.main{
    padding: 82px 88px 130px;
    .tip{
        font-size: 39px;
        line-height: 54px;
    }
    .tip2{
        text-align: right;
        padding-right: 60px;
    }
}
</style>